/*
 * @Author: your name
 * @Date: 2020-10-23 09:30:49
 * @LastEditTime: 2021-05-19 15:38:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zhihui\roses-admin-vue\src\api\common.js
 */
import Vue from 'vue';
import config from '../config/index';

export default {
  // 校验手机号唯一
  checkPhoneUnique(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysUser/checkPhone`, params);
  },
  // 验证手机号是否存在
  checkPhoneExist(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysUser/checkPhoneInSystem`, params);
  },
  // 字典值查询
  getDictType(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/sysDictType/dropDown?code=${params}`);
  },
  // 发送短信
  postSendMessage(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sms/sendShortMessage`, params);
  },
  // 验证短信验证码
  postCheckMessageCode(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sms/verifyShortMessage`, params);
  },
  // 点击app图标时获取提示语和错误码
  getAppStatusTips(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysUser/getAppStatusTips`, params);
  },
  // 选择行业类型
  chooseIndustryList(params) {
    return Vue.axios.post(`${config.base_url}/biz-support-data/industry/getIndustryList`, params);
  },
  // 试用系统
  getApp(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/sysTrialUser/getApp`, { params });
  }
};
